import "@/css/index.css";
import "react-toastify/dist/ReactToastify.css";

import { Outlet } from "react-router";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer } from "react-toastify";

import Navbar from "@/components/structure/Navbar";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { set } from "react-hook-form";

function AppContent() {
  return (
    <div className="bg-white text-gray-900 min-h-screen w-full flex flex-col">
      {/* Header */}
      <Navbar />

      {/* Main Content */}
      <main className="container mx-auto p-4 flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer
        id="pageFooter"
        className="bg-gray-800 text-white text-center p-4 mt-4 w-full"
      >
        <p>&copy; {new Date().getFullYear()} Mitchell Lab, CU AMC, DBMI</p>
      </footer>

      {/* Toast Container */}
      <ToastContainer newestOnTop={false} rtl={false} theme="colored" />
    </div>
  );
}

export function App() {
  return (
    <AuthProvider>
      <GoogleOAuthWrapper>
        <AppContent />
      </GoogleOAuthWrapper>
    </AuthProvider>
  );
}

function GoogleOAuthWrapper({ children }: { children: React.ReactNode }) {
  const { oauthConfig } = useAuth();

  if (oauthConfig === undefined) {
    return <div className="text-black text-center p-5">
      <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />
      Loading site configuration...
    </div>;
  }
  
  if (oauthConfig === null) {
    return <div className="text-red-600 text-center p-5">
      Error: Failed to load OAuth configuration. Please try refreshing the page, or contact the site administrator.
    </div>;
  }

  if (!oauthConfig.google_client_id) {
    return <div className="text-red-600 text-center p-5">
      Error: Google OAuth Client ID is not configured. Please contact the site administrator.
    </div>;
  }

  if (!oauthConfig.django_client_id) {
    return <div className="text-red-600 text-center p-5">
      Error: Django OAuth Client ID is not configured. Please contact the site administrator.
    </div>;
  }

  return (
    <GoogleOAuthProvider clientId={oauthConfig.google_client_id}>
      {children}
    </GoogleOAuthProvider>
  );
}

export default App;
